import YoutubeEmbed from "../../../../src/YoutubeEmbed.js";
import React from 'react';
export default {
  YoutubeEmbed,
  React
};